export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_CONTENT = 'FETCH_CONTENT';

export const SAVE_USER = 'SAVE_USER';
export const UPDATE_USER = 'UPDATE_USER';